import { render, staticRenderFns } from "./DefaultTextField.vue?vue&type=template&id=a081b2c6"
import script from "./DefaultTextField.vue?vue&type=script&lang=js"
export * from "./DefaultTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports